import React from 'react';
import styles from './index.module.scss'

const InnerBanner = (props) => {
  const {compData} = props;
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  return (
    <>
      {compData && 
        <div className={styles.wrapper}>
          <div className={styles.innerWrapper}>
              <div className={styles.imgWrapper}>
                  <img src={isMobile ? compData?.mobileurl : compData?.tableturl} alt={compData?.shortDescription} loading="lazy"/>
              </div>
          </div>
      </div>
      }
    </>
  );
};

export default InnerBanner;
